export const MODAL_POST_STOCK_OPEN = 'MODAL_POST_STOCK_OPEN';
export const MODAL_POST_STOCK_CLOSE = 'MODAL_POST_STOCK_CLOSE';

export const MODAL_POST_STOCK_CONSIGNMENT_OPEN = 'MODAL_POST_STOCK_CONSIGNMENT_OPEN';
export const MODAL_POST_STOCK_CONSIGNMENT_CLOSE = 'MODAL_POST_STOCK_CONSIGNMENT_CLOSE';

export const MODAL_SHIPMENT_CHECK_FIFO_OPEN = 'MODAL_SHIPMENT_CHECK_FIFO_OPEN';
export const MODAL_SHIPMENT_CHECK_FIFO_CLOSE = 'MODAL_SHIPMENT_CHECK_FIFO_CLOSE';

export const MODAL_SHIPMENT_SUBMERGE_OPEN = 'MODAL_SHIPMENT_SUBMERGE_OPEN';
export const MODAL_SHIPMENT_SUBMERGE_CLOSE = 'MODAL_SHIPMENT_SUBMERGE_CLOSE';

export const MODAL_SHIPMENT_REDEEM_CONSIGNMENT_OPEN = 'MODAL_SHIPMENT_REDEEM_CONSIGNMENT_OPEN';
export const MODAL_SHIPMENT_REDEEM_CONSIGNMENT_CLOSE = 'MODAL_SHIPMENT_REDEEM_CONSIGNMENT_CLOSE';

export const MODAL_SHIPMENT_PLAN_READY_OPEN = 'MODAL_SHIPMENT_PLAN_READY_OPEN';
export const MODAL_SHIPMENT_PLAN_READY_CLOSE = 'MODAL_SHIPMENT_PLAN_READY_CLOSE';

export const MODAL_SHIPMENT_RETURN_OPEN = 'MODAL_SHIPMENT_RETURN_OPEN';
export const MODAL_SHIPMENT_RETURN_CLOSE = 'MODAL_SHIPMENT_RETURN_CLOSE';

export const MODAL_SHIPMENT_CANCEL_REASON_OPEN = 'MODAL_SHIPMENT_CANCEL_REASON_OPEN';
export const MODAL_SHIPMENT_CANCEL_REASON_CLOSE = 'MODAL_SHIPMENT_CANCEL_REASON_CLOSE';
export const MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_OPEN = 'MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_OPEN';
export const MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_CLOSE = 'MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_CLOSE';

export const MODAL_SK_OPEN = 'MODAL_SK_OPEN';
export const MODAL_SK_CLOSE = 'MODAL_SK_CLOSE';
export const MODAL_SK_CREATE = 'MODAL_SK_CREATE';
export const MODAL_SK_CREATE_SUCCESS = 'MODAL_SK_CREATE_SUCCESS';
export const MODAL_SK_CREATE_FAIL = 'MODAL_SK_CREATE_FAIL';

export const MODAL_SK_ZIP_OPEN = 'MODAL_SK_ZIP_OPEN';
export const MODAL_SK_ZIP_CLOSE = 'MODAL_SK_ZIP_CLOSE';
export const MODAL_SK_ZIP_CREATE = 'MODAL_SK_ZIP_CREATE';
export const MODAL_SK_ZIP_CREATE_SUCCESS = 'MODAL_SK_ZIP_CREATE_SUCCESS';
export const MODAL_SK_ZIP_CREATE_FAIL = 'MODAL_SK_ZIP_CREATE_FAIL';

export const MODAL_STATUS_CLEAR = 'MODAL_STATUS_CLEAR';

export const MODAL_PROCESSING_START_OPEN = 'MODAL_PROCESSING_START_OPEN';
export const MODAL_PROCESSING_START_CLOSE = 'MODAL_PROCESSING_START_CLOSE';

export const MODAL_SHIPMENT_PLAN_OPEN = 'MODAL_SHIPMENT_PLAN_OPEN';
export const MODAL_SHIPMENT_PLAN_CLOSE = 'MODAL_SHIPMENT_PLAN_CLOSE';

export const MODAL_SHIPMENT_PLAN_CANCEL_OPEN = 'MODAL_SHIPMENT_PLAN_CANCEL_OPEN';
export const MODAL_SHIPMENT_PLAN_CANCEL_CLOSE = 'MODAL_SHIPMENT_PLAN_CANCEL_CLOSE';

export const MODAL_MESSAGE_OPEN = 'MODAL_MESSAGE_OPEN';
export const MODAL_MESSAGE_CLOSE = 'MODAL_MESSAGE_CLOSE';

export const MODAL_ADD_MESSAGE_OPEN = 'MODAL_ADD_MESSAGE_OPEN';
export const MODAL_ADD_MESSAGE_CLOSE = 'MODAL_ADD_MESSAGE_CLOSE';

export const MODAL_QR_LINK_OPEN = 'MODAL_QR_LINK_OPEN';
export const MODAL_QR_LINK_CLOSE = 'MODAL_QR_LINK_CLOSE';

export const MODAL_DELETING_PIECE_OPEN = 'MODAL_DELETING_PIECE_OPEN';
export const MODAL_DELETING_PIECE_CLOSE = 'MODAL_DELETING_PIECE_CLOSE';

export const MODAL_AWAITING_PROCESSING_START_OPEN = 'MODAL_AWAITING_PROCESSING_START_OPEN';
export const MODAL_AWAITING_PROCESSING_START_CLOSE = 'MODAL_AWAITING_PROCESSING_START_CLOSE';

export const MODAL_SHIPMENT_ADD_REPORT_OVERDUE_OPEN = 'MODAL_SHIPMENT_ADD_REPORT_OVERDUE_OPEN';
export const MODAL_SHIPMENT_ADD_REPORT_OVERDUE_CLOSE = 'MODAL_SHIPMENT_ADD_REPORT_OVERDUE_CLOSE';

export const MODAL_SHIPMENT_SZ_REBINDING_OPEN = 'MODAL_SHIPMENT_SZ_REBINDING_OPEN';
export const MODAL_SHIPMENT_SZ_REBINDING_CLOSE = 'MODAL_SHIPMENT_SZ_REBINDING_CLOSE';

export const MODAL_ADD_COMMENT_OPEN = 'MODAL_ADD_COMMENT_OPEN';
export const MODAL_ADD_COMMENT_CLOSE = 'MODAL_ADD_COMMENT_CLOSE';

export const MODAL_ON_HOLD_OPEN = 'MODAL_ON_HOLD_OPEN';
export const MODAL_ON_HOLD_CLOSE = 'MODAL_ON_HOLD_CLOSE';
// Модальное окно опроса
export const MODAL_SURVEY_OPEN = 'MODAL_SURVEY_OPEN';
export const MODAL_SURVEY_CLOSE = 'MODAL_SURVEY_CLOSE';

export const MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_OPEN = 'MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_OPEN';
export const MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_CLOSE = 'MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_CLOSE';

export const MODAL_SELECT_FIELDS_OPEN = 'MODAL_SELECT_FIELDS_OPEN';
export const MODAL_SELECT_FIELDS_CLOSE = 'MODAL_SELECT_FIELDS_CLOSE';
